export default "__VITE_ASSET__Bar8yIS0__"